import { Component, OnInit, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss',
})
export class CallbackComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  private oAuthService: OAuthService = inject(OAuthService);

  public ngOnInit(): void {
    if (this.oAuthService.hasValidAccessToken()) {
      this.oAuthService.loadUserProfile(); 
    }

    setTimeout(() => {
      this.authService.isConnected.next(this.oAuthService.hasValidAccessToken());
    }, 2000);
  }
}
